<template>
<div class="header__wrapper">
  <div class="header">
    <h1 id="logo">
      <a href="/">
        <app-icon type="iconlogo1" />
        <b>采讯</b>
      </a>
    </h1>
    <div class="top-nav">
      <a href="https://app.zcygov.cn" target="_blank" class="app-store">应用市场</a>
      <zcy-modal />
    </div>
  </div>
</div>
</template>

<script>
import request from '@/utils/request';
import AppIcon from '../icon';
import ZcyModal from './modal';

export default {
  name: 'zcy-header',
  components: {
    'app-icon': AppIcon,
    'zcy-modal': ZcyModal
  },
  data () {
    return {
      visible: false,
      form: this.$form.create(this)
    };
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible;
    },
    submit (data) {
      this.confirmLoading = true;
      request('/api/eco/base/saveFeedback', {
        method: 'post',
        data
      }).then(res => {
        if (res.success) {
          this.$message.success('提交成功');
          this.modalVisible = false;
        } else {
          this.$message.error(res.message);
        }
        this.$$nextTick(() => {
          this.confirmLoading = false;
        });
      }).catch(() => {
        this.confirmLoading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.header__wrapper {
    background: #fff;
    .header {
      padding: 10px 0;
      width: 1200px;
      height: 64px;
      padding: 11px 0;
      margin: 0 auto;
      #logo {
        float: left;
        height: 42px;
        a {
          .anticon {
            float: left;
            font-size: 42px;
            margin-right: 12px;
          }
          b {
            float: left;
            color: #384967;
            font-size: 24px;
            font-weight: normal;
            line-height: 42px;
          }
        }
      }
      .top-nav {
        float: right;
        .app-store, .feedback-box {
          float: left;
          line-height: 42px;
          font-size: 14px;
          &:hover {
            color: #00BBEF;
          }
        }
        .feedback-box {
          margin-left: 20px;
          a:hover {
            color: #00BBEF;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue